import React from 'react';

import { useTranslation } from 'react-i18next';
import { useLangNavigate } from 'shared/hooks';

export function BlogSection() {
  const { t } = useTranslation('home');
  const { lang } = useLangNavigate();

  return (
    <section className="relative mx-auto w-full">
      <div
        className="relative h-auto w-full bg-cover bg-center bg-no-repeat md:h-[520px]"
        style={{
          backgroundImage: 'url(/images/home/blog-section.webp)',
        }}
      >
        <div className="absolute inset-0 flex justify-center px-6">
          <div className="flex w-full max-w-[980px] flex-col items-center justify-center py-10 md:py-[84px]">
            <h2 className="text-center text-[24px] font-bold leading-[1.25] tracking-[-0.022em] text-white md:text-[32px]">
              {t('blog.title')}
            </h2>
            <p className="mt-2 text-center text-[14px] leading-[1.5] tracking-[-0.01em] text-[#FFC2C2] md:text-[18px]">
              {t('blog.subtitle')}
            </p>

            <div className="mt-8 w-full max-w-[760px] rounded-[18px] bg-white/15 shadow-[0_12px_40px_rgba(0,0,0,0.18)] backdrop-blur-[2px]">
              <div className="overflow-hidden rounded-[14px]">
                <p className="block w-full bg-white/10 px-4 py-3 text-center text-[15px] leading-[1.4] tracking-[-0.01em] text-white md:px-6 md:py-5 md:text-[20px]">
                  {t('blog.articles.inspection')}
                </p>

                <div className="h-px w-full bg-white/25" />

                <p className="block w-full bg-white/10 px-4 py-3 text-center text-[15px] leading-[1.4] tracking-[-0.01em] text-white md:px-6 md:py-5 md:text-[20px]">
                  {t('blog.articles.medicine')}
                </p>
                <div className="h-px w-full bg-white/25" />

                <p className="block w-full bg-white/10 px-4 py-3 text-center text-[15px] leading-[1.4] tracking-[-0.01em] text-white md:px-6 md:py-5 md:text-[20px]">
                  {t('blog.articles.kpop')}
                </p>
              </div>
            </div>

            <button
              onClick={() => {
                window.dataLayer?.push({ event: 'click_main', menu: 'discover_more_tips', section: 'Blog' });
                window.location.href = lang ? `/${lang}/blog/` : '/blog/';
              }}
              className="mt-8 rounded-[14px] bg-white px-6 py-[14px] text-[15px] font-bold leading-[1.3] tracking-[-0.022em] text-[#FF2D2E] shadow-[0_8px_24px_rgba(0,0,0,0.2)] md:text-[18px]"
            >
              {t('blog.button')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
